import React from 'react';

interface PolygonUpProps {
  className?: string;
  style?: React.CSSProperties;
}

const PolygonUp: React.FC<PolygonUpProps> = ({ className, style }) => {
  return (
    <svg
      width="9"
      height="8"
      viewBox="0 0 9 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M3.34927 0.470016C3.74094 -0.156652 4.6536 -0.156651 5.04526 0.470017L8.24102 5.58322C8.6573 6.24927 8.17845 7.11322 7.39302 7.11322H1.00151C0.216078 7.11322 -0.262765 6.24927 0.153515 5.58322L3.34927 0.470016Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default PolygonUp;
